/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
/// ACTIONS ///
import { updateShopNotchedCorner } from "api/actions/price_list";
/// TYPES ///
import { INotchedCorner } from "api/types/price_list/corner/notched";
/// COMPONENTS ///
import PriceRow from "../../row";
/// VALUES ///
import { getMaterialHeightDisplay } from "values/material";

interface Props {
  index: number,
  last: boolean,
  notched_corner: INotchedCorner
}

export default function NotchedCorner({ index, last, notched_corner }: Props) {
  const dispatch = useAppDispatch();

  return (
    <PriceRow
      index={index}
      last={last}
      original_price={notched_corner?.price ?? 0}
      title={getMaterialHeightDisplay(notched_corner?.material_thickness ?? "")}
      end_text="$"
      end_padding="45px"
      update={price => dispatch(updateShopNotchedCorner({ price: price }, notched_corner.id))} />
  )
}
